import { Directive, ElementRef, Input, EventEmitter, OnInit } from "@angular/core";

@Directive({
  selector: "[hkt-focus]",
})
export class FocusDirective implements OnInit {
  @Input("hkt-focus") focusEvent: EventEmitter<boolean>;

  constructor(private elementRef: ElementRef) {}

  ngOnInit() {
    if (this.focusEvent) {
      this.focusEvent.subscribe(event => {
        this.elementRef.nativeElement.focus();
      });
    }
  }
}
